import { Component, OnInit } from '@angular/core';
import {
  Router, ActivatedRoute, Event as RouterEvent, NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { DashboardService } from '../../shared/services/dashboard.service';
import { AppConfig } from '../../app.config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadNoticationDetailComponent } from '../../views/notification-detail/lead-notication-detail';
import { AssignmentNotifiDetailComponent } from '../../views/notification-detail/assignment-notifi-detail';
import * as moment from 'moment-timezone';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit{
  user: any = {};
  count: any;
  notifications: any = [];
  interval: any;
  photo_url: any;
  moment: any = moment();
  page: number = 1;
  loadingNotificattion = false;
  isSuperAdmin = false;
  constructor(
    public userService: UserService,
    public authService: AuthenticationService,
    public dashboardService: DashboardService,
    public modalService: NgbModal,
    private appConfig: AppConfig,
    private router: Router,
    public toastr: ToastrManager
  ) {
  }
  ngOnInit() {
    if (this.authService.user) {
      this.findById(this.authService.user.id);
    }
    this.getNotificationCount();
    this.authService.user$.subscribe(user => setTimeout(() => { console.log(user); this.photo_url = user && user.photo_url, 0 }));
  }
  findById(id: any) {
    this.userService.findById(id).subscribe(
      data => {
        this.user = data;
        this.photo_url = this.user.photo_url;
        // console.log(this.user);
      }, error => {

      });
  }
  getNotificationCount() {
    this.dashboardService.getNotificationCount().subscribe(
      data => {
        this.count = data.count[0].count;
        console.log(this.count);
      },
      error => { })
  }
  openNotificationDetatil(ev, notifications) {
    this.copyText(notifications.description);
    if (notifications.target === 'LEAD_NOT_ATTENDED') {
      const modalRef = this.modalService.open(LeadNoticationDetailComponent, { size: 'lg' });
      modalRef.componentInstance.leadNoticationDetail = notifications;
      modalRef.result.then((data) => {
      }).catch((error) => {

      });
    }
    if (notifications.target === 'ASSIGNMENT_NOT_DONE') {
      const modalRef = this.modalService.open(AssignmentNotifiDetailComponent, { size: 'lg' });
      modalRef.componentInstance.assignNoticationDetail = notifications;
      modalRef.result.then((data) => {
      }).catch((error) => {

      });
    }
  }
  getAllNotifications(e, isExport) {
    if (e === undefined && isExport === undefined) {
      this.page = 1;
      this.notifications = [];
    }
    if (this.authService.user) {
      if (this.authService.user.role_name === 'SUPER_ADMIN') {
        this.isSuperAdmin = true;
      }
    }
    this.loadingNotificattion = true;
    if (e) {
      e.stopPropagation();
    }
    this.dashboardService.getAllNotifications(isExport, this.page).subscribe(
      data => {
        if (isExport) {
          window.open(this.appConfig.apiUrl + 'document/report/' + data.name + '?_t=' + this.authService.token);
          console.log(this.appConfig.apiUrl + 'document/report/' + data.name + '?_t=' + this.authService.token);
          this.loadingNotificattion = false;
        } else {
          if (data.notifications.length > 0) {
            let resData = [];
            data.notifications.forEach((notificationData, index) => {
              let res = notificationData;
              res.created_at = moment(notificationData.created_at).tz('asia/kolkata').format('YYYY-MM-DD hh:mm a');
              resData.push(res);
              if (index + 1 === data.notifications.length) {
                this.notifications = this.notifications.length > 0 ? this.notifications.concat(resData) : resData;
              }
            });
          }
          this.loadingNotificattion = false;
        }
      },
      error => {
        this.loadingNotificattion = false;
      })
  }

  copyText(val: string) {
    if (val) {
      this.toastr.successToastr(val, 'Text Copied!');
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  onScroll(event) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.page = this.page + 1;
      if (this.loadingNotificattion === false) {
        this.getAllNotifications(null, false);
      }
    }
  }
  logout() {
    // alert('inside logout');
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-header/app-header.component.ts